import React from 'react'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { store } from '@/store'
import router from '@/router'
import WalletProvider from '@/components/Web3/WalletProvider'
import './App.less'

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ConfigProvider locale={zhCN}>
        <WalletProvider>
          <RouterProvider router={router} />
        </WalletProvider>
      </ConfigProvider>
    </Provider>
  )
}

export default App
